import React from "react";
import Layout from "Layout";
import Form from "./form";
import useApi from "Hooks/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";
import useAuth from "Hooks/useAuth";
import googleAnalytics from "fuction/googleAnalytics";

function Labels(props) {
  const { request } = useApi();
  const { state } = useAuth();
  const stateError = useError();
  const messages = message();
  const [accountAttr, setAccountAttr] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 分類辞書登録";

    fetchAccountAttr();
  }, [state.user.account_id]);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, state.user.account_id);
  }, [props.location.pathname]);

  const fetchAccountAttr = () => {
    if (!state.user.account_id) {
      return;
    }
    // 分類辞書に登録できる検知語の最大数を取得する
    request({
      method: "POST",
      url: `config/:account_id/account`,
      data: {
        "attrs": [
          "max_label_words",
        ]
      },
    }).then((result) => {
      setAccountAttr(result.data);
    });
  };

  const handleSubmit = ({ name, desc, label, filteredWords, ignore_case }) => {
    request({
      method: "POST",
      url: `config/:account_id/analysis/labels`,
      data: {
        name: name,
        desc: desc,
        label: label,
        words: filteredWords,
        ignore_case: ignore_case,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/config/dictionarysetting/classification?success=create");
      })
      .catch((error) => {
        let errorMsg = messages.validation.common;
        // 辞書登録上限数超過
        if (error.response.data.errors?.num_labels?.[0].error == "over_limit") {
          errorMsg = messages.errorMsg.overLimit;
        }
        // 辞書名重複
        if (error.response.data.errors?.name?.[0].error == "taken") {
          errorMsg = messages.errorMsg.duplicateDictName + "（" + error.response.data.errors.name[0].value + "）";
        }
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: errorMsg,
          },
        });
      });
  };
  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
          accountAttr={accountAttr}
        />
      }
    />
  );
}
export default withRouter(Labels);
